import script from "./FbaStorageFeeTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./FbaStorageFeeTrend.vue?vue&type=script&setup=true&lang=js"

import "./FbaStorageFeeTrend.vue?vue&type=style&index=0&id=7a6cdcc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6cdcc8"]])

export default __exports__